module.exports = __webpack_public_path__ + "img/mycart_01.2816eee2.png";